import { createSelector } from 'reselect'
import { marketApi } from '@envato/foundation-types'

import { IRootState } from '../../common/reducers'
import { getCategoriesList } from '../../common/utils/categoryPage'

export const selectCategoriesList = createSelector<
  IRootState,
  marketApi.ICategory[],
  marketApi.ICategory[]
>([state => state.common.categoriesWithChildren], getCategoriesList)

export const selectItemCountForCategory = (
  state: IRootState,
  categoryPath: string
) => {
  const categories = selectCategoriesList(state)
  const category = categories.find(category => category.path === categoryPath)
  return category ? category.number_of_items : 0
}
